export const definitionParams = {
  fields: [
    {
      name: 'probability',
      type: 'esriFieldTypeSingle',
      actualType: 'real',
      alias: 'probability',
      sqlType: 'sqlTypeReal',
      nullable: true,
      editable: false,
      domain: null,
      defaultValue: null,
    },
    {
      name: 'ObjectId',
      type: 'esriFieldTypeOID',
      actualType: 'int',
      alias: 'ObjectId',
      sqlType: 'sqlTypeInteger',
      nullable: false,
      editable: false,
      domain: null,
      defaultValue: null,
    },
    {
      name: 'Shape__Area',
      type: 'esriFieldTypeDouble',
      actualType: 'float',
      alias: 'Shape__Area',
      sqlType: 'sqlTypeFloat',
      nullable: true,
      editable: false,
      domain: null,
      defaultValue: null,
    },
    {
      name: 'Shape__Length',
      type: 'esriFieldTypeDouble',
      actualType: 'float',
      alias: 'Shape__Length',
      sqlType: 'sqlTypeFloat',
      nullable: true,
      editable: false,
      domain: null,
      defaultValue: null,
    },
  ],
};
